import React from 'react';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { errorText } from './Content';
import GenericError from './Errors/GenericError';
import { PsBeaconButton } from './BeaconRegister';

const handleRefresh = () => {
    // e.preventDefault();
    window.location.reload(true);
};

export default function ServiceErrorCard({ showButton, showCloseButton }) {
    const switchButtonText = () => {
        if (showButton) {
            return 'Refresh Page';
        }
        if (showCloseButton) {
            return 'Close Page';
        }
        return '';
    };

    const switchContentText = showButton
        ? 'Thanks for your patience. Please try refreshing your page or check back later.'
        : 'Thanks for your patience. Please close your page and check back later.';

    return (
        <Box
            sx={{
                backgroundColor: '#F4F5F6',
                inlineSize: 'unset',
                paddingTop: '80px',
                paddingBottom: '80px',
            }}
            id="service-error-container"
            className="b-container-content">
            <GenericError title="Sorry, something went wrong" id="service-card-error">
                <Box sx={{ paddingBottom: '24px' }}>{switchContentText}</Box>
                <Box sx={{ paddingBottom: '24px' }}>{errorText}</Box>
                {showButton && (
                    <Box>
                        <PsBeaconButton
                            id={showButton ? 'error-modal-refresh' : 'error-modal-close'}
                            onclick={handleRefresh}
                            scale="jumbo">
                            {switchButtonText()}
                        </PsBeaconButton>
                    </Box>
                )}
            </GenericError>
        </Box>
    );
}
